module.exports = __webpack_public_path__ + "static/media/payroll-min.f49a39cc.jpg";